import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SectionRenderer from './SectionRenderer';
import { galleryItems, pricingCategories as fallbackPricing } from '../../mock';
import { logWarn } from '../../lib/logger';

// Renders a full builder page ({sections:[...]}) — used by the public homepage and
// the editor preview. Manages the quote dialog + pricing fetch that section blocks need.
export default function PageRenderer({ page, quoteDialogOpen: extDialog, setQuoteDialogOpen: extSetDialog }) {
  const [localDialog, setLocalDialog] = useState(false);
  const quoteDialogOpen = extDialog ?? localDialog;
  const setQuoteDialogOpen = extSetDialog ?? setLocalDialog;
  const [pricingCategories, setPricingCategories] = useState(fallbackPricing);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/pricing`);
        if (!cancelled && Array.isArray(data) && data.length > 0) setPricingCategories(data);
      } catch (err) {
        logWarn('Pricing API unavailable, using fallback:', err?.message || err);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  const ctx = { pricingCategories, galleryItems, quoteDialogOpen, setQuoteDialogOpen };
  const sections = (page?.sections || []).filter((s) => s && s.visible !== false);

  return (
    <>
      {sections.map((section) => (
        <SectionRenderer key={section.id} section={section} ctx={ctx} />
      ))}
    </>
  );
}
